import logo from "assets/images/brands/brand-main-sm.png";

export const clientName = "Exinitic";
export const developedBy = "Exinitic";

export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL || "http://localhost:4002/";
export const companyName = "Exinitic CRM";
export const sidebarLogo = logo;
export const mainLogo = logo;